<div [outerHTML]="message"></div>
